// action types
export const ACTION_TYPE_PAGE_VIEW = 12;

export const ACTION_TYPE_HELPER_ENTRY_BOX = 13;
export const ACTION_TYPE_HELPER_LAUNCH = 14;
export const ACTION_TYPE_HELPER_BRAND_SELECT = 15;

export const ACTION_TYPE_DASHBOARD_CSV_EXPORT = 16;
export const ACTION_TYPE_DASHBOARD_PNG_EXPORT = 17;
export const ACTION_TYPE_DASHBOARD_BRAND_SELECT = 18;
export const ACTION_TYPE_DASHBOARD_DATE_SELECT = 19;
export const ACTION_TYPE_DASHBOARD_FILTER_REDIRECT = 20;

export const ACTION_TYPE_SEARCH_CSV_EXPORT = 21;
export const ACTION_TYPE_SEARCH_FILTER_SELECT = 22;

// event types
export const EVENT_TYPE_CLICK = 1

// action module
export const ACTION_MODULE_NEW_UI_NAVIGATION_CHANGE = 'NewUI.NavigationChange'
export const ACTION_MODULE_NEW_UI_HELPER = 'NewUI.Helper'
export const ACTION_MODULE_NEW_UI_DASHBOARD = 'NewUI.Dashboard'